module.exports = __webpack_public_path__ + "Poppins-Bold.7940efc40d8e3b477e16.ttf";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/fonts/poppins/Poppins-Bold.ttf
// module id = ../../../../../src/assets/fonts/poppins/Poppins-Bold.ttf
// module chunks = main